import { WSTable } from "@wingspanhq/fe-component-library";
import { InternalAccount, Statement } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";
import { getColumns } from "./columns";
import styles from "./styles.module.scss";

export type TableItemData = Statement;

type Props = {
  statements: Statement[];
  internalAccount?: InternalAccount;
  loading?: boolean;
  downloadDisabled?: boolean;
  onDownload: (statement: Statement) => Promise<void> | void;
};

export const TableStatements: React.FC<Props> = props => {
  const tableData = useMemo(
    () =>
      props.statements.map(statement => ({
        id: statement.id,
        data: statement
      })),
    [props.statements]
  );

  const columns = useMemo(
    () => getColumns({ internalAccount: props.internalAccount }),
    [props.internalAccount]
  );

  return (
    <WSTable<TableItemData>
      loading={props.loading}
      showHeader
      columns={columns}
      tableData={tableData}
      rowActions={({ data }) => [
        {
          label: " ",
          text: "Download",
          icon: "download",
          className: styles.downloadIcon,
          disabled: props.downloadDisabled,
          hideOn: [],
          onAsyncClick: async () => {
            await props.onDownload(data);
          }
        }
      ]}
    />
  );
};
